module.exports={
	"Scope": "DocumentApprovalStep-List",
	"CoreEntity": "DocumentApprovalStep",
	"TitleTemplate": "Document Approval Steps",
	"Descriptors":
	{
		"IDDocumentApprovalState":
		{
			"Name": "State ID",
			"Hash": "DocStepListIDState",
			"PictDashboard": {}
		},
		"Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "DocStepListOrdinal",
			"PictDashboard": {}
		},
		"IDRole":
		{
			"Name": "Role ID",
			"Hash": "DocStepListIDRole",
			"PictDashboard": {}
		},
		"IncludeHigherRoles":
		{
			"Name": "Higher Roles",
			"Hash": "DocStepListHigherRoles",
			"PictDashboard": {}
		},
		"PerformLock":
		{
			"Name": "Lock",
			"Hash": "DocStepListLock",
			"PictDashboard": {}
		}
	}
}
